import { useNavigate } from "@tanstack/react-router"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "design-system/molecules/Tabs"
import { MessageSquareText, ScrollText } from "lucide-react"
import { useTranslation } from "react-i18next"
import { Route } from "routes/_base/_auth/campaigns/$id/activity/route"
import { CampaignLogs } from "../CampaignLogs"
import { CampaignResponses } from "../Responses"

type Props = {
  section?: string
}

export function Activity({ section }: Props) {
  const { t } = useTranslation()
  const navigate = useNavigate({ from: "/campaigns/$id/activity" })
  const { id } = Route.useParams()
  const search = Route.useSearch()
  const activeTab = section ?? "responses"

  const tabs = [
    { name: t("campaigns.activity.tabs.responses"), value: "responses", icon: MessageSquareText },
    { name: t("campaigns.activity.tabs.logs"), value: "logs", icon: ScrollText },
  ]

  return (
    <Tabs
      variant="pill"
      orientation="horizontal"
      value={activeTab}
      onValueChange={(value) => {
        navigate({
          to: "/campaigns/$id/activity",
          params: { id },
          search: { section: value },
        })
      }}
      className="flex lg:flex-row flex-col items-start gap-6"
    >
      <TabsList className="max-w-full sticky top-20 lg:grid lg:grid-cols-1 gap-1 p-0 bg-background shrink-0 flex flex-row items-start justify-start overflow-x-auto overflow-y-hidden md:overflow-visible z-20">
        {tabs.map((tab) => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className="min-w-fit lg:min-w-48 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground px-3 py-1.5 flex items-center justify-between gap-2.5"
          >
            <div className="flex items-center gap-2.5">
              <tab.icon className="h-5 w-5" />
              <span>{tab.name}</span>
            </div>
          </TabsTrigger>
        ))}
      </TabsList>
      <div className="h-auto w-full min-w-0 flex-1 overflow-x-auto">
        <TabsContent value="responses" className="h-full w-full">
          <CampaignResponses />
        </TabsContent>
        <TabsContent value="logs" className="h-full w-full">
          <CampaignLogs id={id} search={search} fullPath="/campaigns/$id/activity" />
        </TabsContent>
      </div>
    </Tabs>
  )
}
